<template>
  <div class="article-detail">
    <Nav :isColor="isPC" />
    <div class="text-content">
      <div class="text-top">
        <div class="head">
          <p class="line" v-if="isPC"></p>
          <p class="title">{{ article.title }}</p>
        </div>
        <div class="other">
          <div style="display: flex; justify-content: center">
            <img class="otherImg" src="../../assets/images/type.png" alt="" />
            {{ articleType[article.type] }}
          </div>
          <div style="display: flex; justify-content: center">
            <img class="otherImg" src="../../assets/images/data.png" alt="" />
            发布时间：{{ article.updateTime }}
          </div>
        </div>
      </div>

      <div class="content1" v-html="article.content"></div>
    </div>

    <Footer v-if="isPC" class="top" />
    <PhFooter v-else></PhFooter>
  </div>
</template>

<script>
import { getArticleById } from '@/api/index' // 假设你有一个API文件来处理请求

export default {
  name: 'ArticleDetail',
  data() {
    return {
      article: {},
      articleType: ['公司动态', '门店风采'],
      outerWidth: window.innerWidth, // 屏幕宽度
      error: null
    }
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    }
  },
  mounted() {
    // 初始化
    this.updateOuterWidth()
    window.addEventListener('resize', this.updateOuterWidth)
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('resize', this.updateOuterWidth)
  },
  async created() {
    try {
      const articleId = this.$route.params.id
      // console.log('Fetching article with ID:', articleId)
      const response = await getArticleById(articleId)
      // console.log('article data received:', response)
      if (response.code === 200) {
        this.article = response.data
      } else {
        throw new Error(response.msg || '获取资讯详情失败')
      }
    } catch (error) {
      console.error('获取资讯详情失败:', error)
      this.error = '获取资讯详情失败，请稍后再试'
      // 可以添加更多的错误处理逻辑，比如显示一个错误提示
    }
  },
  methods: {
    // 更新 outerWidth
    updateOuterWidth() {
      this.outerWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
.otherImg {
  margin-right: 5px;
}
.article-detail {
  background: rgba(170, 212, 250, 0.1);
  font-family: PingFangSC, PingFang SC;
}
.text-content {
  background: #fff;
  width: 1486px;
  margin: 40px auto 115px;
  .text-top {
    width: 1200px;
    margin: auto;
    border-bottom: 2px #f4f4f4 solid;
  }
  .head {
    display: flex;
    padding-top: 65px;
    /* padding-bottom: 20px; */
    .line {
      width: 4px;
      height: 30px;
      background: #0851b0;
      margin-right: 10px;
    }
  }

  .title {
    font-weight: 500;
    font-size: 30px;
    color: #0b1d30;
    line-height: 30px;
  }
  .other {
    display: flex;
    justify-content: space-between;
    margin: 30px 0 30px 0;
    font-size: 16px;
    line-height: 16px;
    color: #999;
  }
}
.content1 {
  line-height: 34px;
  width: 1200px;
  margin: 60px auto 0;
  padding-bottom: 60px;
}
@media (max-width: 768px) {
  .text-content {
    width: 348px;
    margin: 20px auto 40px;
    .text-top {
      width: 291px;
    }
    .head {
      display: flex;
      padding-top: 19px;
    }
    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }
    .other {
      display: flex;
      justify-content: space-between;
      margin: 16px 0 16px 0;
      font-size: 12px;
    }
  }
  .content1 {
    line-height: 24px;
    width: 291px;
    margin: 20px auto 0;
    padding-bottom: 20px;
  }
}
</style>
<style lang="scss">
@media (max-width: 768px) {
  #app {
    background: rgba(170, 212, 250, 0.1);
  }
}
</style>
